import React from 'react';
import { motion } from 'framer-motion';
import faqBg from '../assets/faq.png';
import robotIcon from '../assets/robot.png';
import ServicesWheel from "../components/wheel";
import ServicesPhilosophy from "../components/philosophy";
import banner2 from '../assets/banner2.png';
import { Link } from "react-router-dom";
const BespokePortfolios = () => {
  const approachItems = [
    { title: "Risk & Objective Alignment", desc: "A bespoke portfolio begins with clarity. Understanding risk appetite, liquidity requirements, time horizon, and long-term financial objectives forms the foundation of structured allocation. Suitability remains central to every allocation framework." },
    { title: "Strategic Asset Allocation", desc: "Assets are structured across equity, fixed income, and alternative avenues to balance growth and preservation. Allocation decisions are guided by long-term discipline rather than short-term market movements." },
    { title: "Coordinated Multi-Asset Exposure", desc: "Exposure may be facilitated across regulated investment avenues including mutual funds, PMS, AIFs, direct equities where appropriate, and legacy-oriented structures. Every allocation remains aligned with suitability considerations and long-term wealth priorities." },
    { title: "Ongoing Portfolio Review", desc: "Periodic portfolio reviews are conducted to assess alignment with evolving financial objectives and changing market conditions. Structured rebalancing considerations help maintain long-term discipline and consistency within the allocation framework." },
    
  ];



  return (
    <div className="bg-white min-h-screen">
 <section
  className="relative pt-16 pb-20 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

  <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
            Bespoke Portfolios
        </h3>

  <div
    className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
    style={{
      background:
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
    }}
  />
</section>


<ServicesWheel />
    <ServicesPhilosophy/>  
      {/* SECTION 1: HEADER 
      <section className="py-12 md:py-16 text-center border-b border-slate-50" style={{ backgroundImage: `url(${faqBg})`, backgroundSize: "cover" }}>
        <h3 className="font-syne text-[28px] md:text-[40px] text-slate-900 tracking-tight font-medium">Bespoke Portfolios</h3>
      </section>

      
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <motion.img 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            src={bespokeWheel} 
            alt="What We Offer" 
            className="w-full max-w-3xl mx-auto"
          />
        </div>
      </section>
      */}

      {/* SECTION 3: OUR APPROACH GRID */}
 {/* SECTION 3: OUR APPROACH (Balanced Professional Layout) */}
<section className="py-24 bg-white relative">
  {/* Subtle section watermark matching the theme */}
  <div className="absolute inset-0 opacity-[0.03] pointer-events-none" 
       style={{ backgroundImage: `url(${faqBg})`, backgroundSize: '600px' }}></div>

  <div className="max-w-7xl mx-auto px-6 lg:px-24 relative z-10">
    <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
      
      {/* LEFT SIDE: Heading & Anchor Content (Now balanced) */}
      <div className="lg:w-1/3">
        <div className="lg:sticky lg:top-32">
          <div className="flex items-center gap-3 mb-6">
            
            
          </div>
          
         

           <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
   Our  Approach
  </h3>
          
          <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-8">
           Significant wealth requires more than product selection. It demands structure, discipline, and clarity of purpose.
          </p>

          {/* This small detail fills the "emptiness" and adds a premium feel */}
          <div className="hidden lg:block p-6 border-l border-slate-100 bg-slate-50/50 rounded-r-xl">
             <p className="text-slate-600 text-base md:text-md leading-relaxed mb-4 font-medium italic">
               "A Structured Philosophy, Not a Standard Template"
             </p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE: The Grid Cards */}
      <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-8">
        {approachItems.map((item, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`p-8 rounded-2xl bg-white border border-slate-100 shadow-[0_10px_40px_rgba(0,0,0,0.03)] group transition-all duration-500 
              ${index === 4 ? 'md:col-span-2' : ''}
            `}
            style={{
               backgroundImage: `url(${faqBg})`,
               backgroundSize: '300px',
               backgroundBlendMode: 'soft-light',
               backgroundColor: 'rgba(255,255,255,0.98)'
            }}
          >
            <div className="flex items-start gap-4 mb-4">
              {/* Signature Red Accent */}
              <span className="w-1.5 h-7 bg-red-600 rounded-full flex-shrink-0"></span>
              <h4 className="font-syne text-xl font-bold text-slate-900 group-hover:text-red-700 transition-colors">
                {item.title} 
              </h4>
            </div>
            <p className="text-slate-600 text-base md:text-lg font-medium">
              {item.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </div>
</section>

     
     
     {/* SECTION 4: CO-PILOT BANNER (Exact Screenshot Style) */}
{/* SECTION 4: CO-PILOT BANNER (Exact Screenshot Clone) */}
<section className="pb-20 pt-2 bg-white">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="relative rounded-2xl overflow-hidden shadow-sm border border-slate-100"
      style={{
        backgroundImage: `url(${faqBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* The light overlay to make it look "parchment-like" as per screenshot */}
      <div className="absolute inset-0 bg-white/40"></div>

      <div className="relative z-10 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
        
        {/* Left: The Robot with its blue base */}
        <div className="w-full lg:w-1/4 flex justify-center lg:justify-start">
          <img 
            src={robotIcon} 
            alt="Robot Co-pilot" 
            className="w-48 h-48 object-contain scale-110" 
          />
        </div>

        {/* Right: The Text & Grid */}
        <div className="w-full lg:w-3/4">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
            
            {/* Quote and Button Block  */}
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-syne text-slate-900 leading-tight mb-8">
                “Hi, I am your trusted <br /> friend and financial co-pilot.”
              </h2>
              
            <a 
  href="https://calendly.com/dreamladdercapital/portfolio-discussion-meeting" 
  target="_blank" 
  rel="noreferrer" 
  className="flex items-center w-fit mx-auto px-3 py-1 md:px-4 bg-red-600 border-2 border-red-600 text-white rounded-full hover:bg-[#434242] hover:border-[#434242] transition duration-300 font-medium text-[10px] md:text-[16px] shadow-xl shadow-red-900/20 tracking-wide ml-4"
>
  
  Book your slot
</a>
            </div>

            {/* The Feature Grid exactly like the image */}
            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-2">
             
              {[
                { label: "Diversification", icon: "📊" },
                { label: "Unbiased", icon: "⚖️" },
                { label: "Simple & Jargon-free", icon: "🏆" },
                { label: "Follow Portfolio approach", icon: "💼" },
                { label: "Constant monitoring & re-balancing", icon: "🔄" },
                { label: "Regular Hypothesis testing", icon: "🚀" }
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  {/* Small Red Outlined Icons as per screenshot */}
                  <div className="text-red-500 text-lg">
                    {/* You can replace this with your specific asset icons */}
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </div>
                  <span className="text-slate-600 text-lg md:text-xl leading-relaxed">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </motion.div>
  </div>
</section>

{/* SECTION 2: SERVICES WHEEL */}




      {/* FOOTER ACTION BAR */}
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-24">
          <div className="bg-[#333333] rounded-xl px-12 py-3 flex flex-col md:flex-row items-center justify-between">
            <h3 className="text-white text-lg font-bold">For more information</h3>
            <div className="flex gap-4">
            {/*   <button className="px-6 py-2 bg-red-600 text-white text-[11px] font-bold rounded uppercase tracking-wider hover:bg-red-700 transition-all">Read more</button> */}
               <Link to="/blogs">
  <button className="px-6 py-2 bg-red-600 text-white text-[11px] font-bold rounded uppercase tracking-wider hover:bg-red-700 transition-all">
    Read more
  </button>
</Link>
            {/*  <button className="px-6 py-2 bg-red-600 text-white text-[11px] font-bold rounded uppercase tracking-wider hover:bg-red-700 transition-all">Contact Us</button> */}
              <Link to="/connect">
  <button className="px-6 py-2 bg-red-600 text-white text-[11px] font-bold rounded uppercase tracking-wider hover:bg-red-700 transition-all">
    Contact Us
  </button>
</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BespokePortfolios;